export const simple = (obj) => {
    let handleType = obj.handleType || '输入';
    let fieldName = obj.fieldName || '';
    let required = obj.required || false;
    let min = obj.min || null;
    let max = obj.max || null;
    let pattern = obj.pattern || null;
    let res = [];
    if (required) {
        res.push({
            required: true,
            type: obj.type || null,
            message: '请' + handleType + fieldName,
            trigger: ['blur', 'change'],
        })
    }
    if (min && min > -1) {
        res.push({
            min: min,
            message: '长度需大于 ' + min + ' 个字符',
            trigger: ['blur', 'change'],
        })
    }
    if (max) {
        res.push({
            max: max,
            message: '长度需小于 ' + max + ' 个字符',
            trigger: ['blur', 'change'],
        })
    }
    if (pattern) {
        res.push({
            pattern: pattern,
            message: '请' + handleType + '正确的' + fieldName,
            trigger: ['blur', 'change'],
        })
    }
    return res
}

export const mail = (fieldName = "邮箱地址", required = true) => {
    let res = simple({
        fieldName,
        required: required,
        max: 50
    });
    res.push(
        // 邮箱地址正则
        {
            pattern: required ?
                /^[A-Za-z0-9\u4e00-\u9fa5_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/ :
                /^$|^[A-Za-z0-9\u4e00-\u9fa5_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
            // 正则检验前先将值转为字符串
            transform(value) {
                return String(value);
            },
            message: fieldName + '格式不正确',
            trigger: ['blur', 'change'],
        }
    )
    return res;
}

export const name = (fieldName = "姓名") => {
    return simple({
        fieldName,
        required: true,
        max: 50
    })
}

export const password = (fieldName = "密码") => {
    return simple({
        fieldName,
        required: true,
        min: 6,
        max: 20
    })
}

export const verificationCode = (fieldName = "验证码") => {
    return simple({
        fieldName,
        required: true
    })
}

export const phoneNumber = (fieldName = "联系方式", required = true) => {
    let res = simple({
        fieldName,
        required: required,
        max: 20,
        pattern: required ? /^(?:(?:\+|00)86)?1\d{10}$/ : /^$|^(?:(?:\+|00)86)?1\d{10}$/
    });
    return res;
}



export const number = (fieldName = "数字", min = 0, max = 2147483647) => {
    let res = simple({
        fieldName,
        type: 'number',
        required: true
    });
    res.push({
        min: min,
        type: 'number',
        message: fieldName + '需大于 ' + min,
        trigger: ['blur', 'change'],
    })
    res.push({
        max: max,
        type: 'number',
        message: fieldName + '需小于 ' + max,
        trigger: ['blur', 'change'],
    })
    return res;
}

export const array = (fieldName = "", handleType = '选择', min = 1, max = 1000) => {
    let res = simple({
        handleType: handleType,
        type: 'array',
        fieldName,
        required: min == 0 ? false : true
    });
    return res;
}

export const perms = () => {
    let res = simple({
        fieldName: '权限字符',
        max: 50,
    });
    res.push(
        // 仅输入小写英文字母及英文冒号:
        {
            pattern: /^[a-z:]+$/,
            // 正则检验前先将值转为字符串
            transform(value) {
                return String(value);
            },
            message: '权限字符仅支持小写英文字母及英文冒号:',
            trigger: ['blur', 'change'],
        }
    )
    return res;
}

// 数量，选择的数量
export const quantity = (fieldName = "数量", min = 1, max = 2147483647) => {
    return simple({
        fieldName,
        type: 'number',
        required: true
    }).concat({
        min: min,
        type: 'number',
        message: '最少选择 ' + min + ' 个 ' + fieldName,
        trigger: ['blur', 'change'],
    }).concat({
        max: max,
        type: 'number',
        message: '最多选择 ' + max + ' 个 ' + fieldName,
        trigger: ['blur', 'change'],
    });
}


// WEBPACK FOOTER //
// ./src/utils/ruleUtil.js